/** Events Types */
export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';

export const GET_EVENTS_GRAPH_DATA = 'GET_EVENTS_GRAPH_DATA';
export const GET_EVENTS_GRAPH_DATA_SUCCESS = 'GET_EVENTS_GRAPH_DATA_SUCCESS';

export const CREATE_EVENT = 'CREATE_EVENT';
export const EDIT_EVENT = 'EDIT_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const GET_EVENT_GRAPH = 'GET_EVENT_GRAPH';
export const GET_EVENT_GRAPH_SUCCESS = 'GET_EVENT_GRAPH_SUCCESS';

/** End */
